export { Box } from '@mantine/core'
